import React from 'react';
import { TemplateLibrary } from './pages/TemplateLibrary';
export function App() {
  return <TemplateLibrary data-id="element-0" />;
}